export default function FormatTime(date: Date | string | null | undefined, delimiter: string = ":"): string {
  if (date) {
    if (typeof date === "string") {
      if (!isNaN(Date.parse(date))) {
        date = new Date(date)
      }
    }
    if (date instanceof Date) {
      return [
        ("0" + date.getHours()).slice(-2),
        ("0" + date.getMinutes()).slice(-2)
      ].join(delimiter)
    }
  }
  return ""
}
